import React from "react";
import IconActionGroup from "../../../library/IconActionGroup";
import PhaseCreditBadges from "./PhaseCreditBadges";
import {
    StyledDragHandle,
    StyledPhaseName,
    StyledRearrangeRowContent,
    StyledRearrangeRowMain,
} from "./studyPaths.styles";

/**
 * One phase row in Re-arrange mode — a drag handle, name, credit chips, and Edit + Delete actions
 * shown directly (SPEC2 R1), same as the Study Phases list — see `PhaseCard.js`.
 * @param {object} props.phase A phase row from `useStudyPathPhaseList` (with `*_supplied_credits`).
 */
function PhaseRearrangeRow({ phase, onEdit, onDelete, editDisabled = false, editDisabledReason, deleteDisabled = false, deleteDisabledReason }) {
    return (
        <StyledRearrangeRowContent>
            <StyledRearrangeRowMain>
                <StyledDragHandle className="fal fa-grip-dots-vertical" aria-hidden="true" />
                <StyledPhaseName>{phase.name}</StyledPhaseName>
                <PhaseCreditBadges phase={phase} />
            </StyledRearrangeRowMain>

            <IconActionGroup
                collapseAfterFirst={false}
                actions={[
                    {
                        icon: "edit",
                        ariaLabel: "Edit phase",
                        title: `Edit ${phase.name}`,
                        variant: "solid",
                        disabled: editDisabled,
                        disabledReason: editDisabledReason,
                        onClick: () => onEdit(phase),
                    },
                    {
                        icon: "trash-alt",
                        ariaLabel: "Delete phase",
                        title: `Delete ${phase.name}`,
                        variant: "destructive",
                        disabled: deleteDisabled,
                        disabledReason: deleteDisabledReason,
                        onClick: () => onDelete(phase),
                    },
                ]}
            />
        </StyledRearrangeRowContent>
    );
}

PhaseRearrangeRow.displayName = "PhaseRearrangeRow";

export default PhaseRearrangeRow;
